// Author lidongxu
// Date 2024-01-05 15:48:37

class SithMesStoolTransferTicketGenerationRecord {
constructor({
        id = null,
        transferTicketNo = '',
        attachment = '',
        remark = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.transferTicketNo = transferTicketNo;
    this.attachment = attachment;
    this.remark = remark;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new SithMesStoolTransferTicketGenerationRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'transferTicketNo',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.transferTicketNo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicant',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.applicant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicantTime',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.applicantTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'originFileName',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.originFileName',
        sortable: true,
        form: {
        type: 'input',
            linkTo:'common_link',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentList',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodes',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.orderCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCodes',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.projectCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsCodes',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.wbsCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'operationSeqs',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.operationSeqs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'operationDescs',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.operationDescs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prCodes',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.grid.prCodes',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    transferTicketNoFilter : '',
    transferTicketNoListFilter : [],
    applicantFilter : '',
    orderCodeFilter : '',
    projectCodeFilter : '',
    wbsFilter : '',
    prFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'transferTicketNoFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.transferTicketNo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicantFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.applicant',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.orderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.wbs',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prFilter',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.filter.pr',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'transferTicketNo',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.entity.transferTicketNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.sith.stool.sithMesStoolTransferTicketGenerationRecord.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachment'
                }
        }
]

export {SithMesStoolTransferTicketGenerationRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
